import React from "react"

import SectionContainer from "../components/SectionContainer"
import LanguageTag from "../components/LanguageTag"

import usaFlag from "../images/usaflag.png"
import bdFlag from "../images/bdflag.png"


// English
const EnglishTag = () => {
  return (
    <LanguageTag
      language="English"
      flag={usaFlag}
      proficiency="Native"
    />
  )
}

const BengaliTag = () => {
  return (
    <LanguageTag
      language="Bengali"
      flag={bdFlag}
      proficiency="Native"
    />
  )
}

// Full section
const LanguagesSection = () => (
  <SectionContainer header="Languages I speak">
    <EnglishTag />
    <BengaliTag />
  </SectionContainer>
)

export default LanguagesSection
